var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00170898 20.0002C-0.00170898 8.95454 8.95261 0.000244141 19.9983 0.000244141C25.3026 0.000244141 30.3897 2.10738 34.1405 5.85809C37.8911 9.60884 39.9983 14.6959 39.9983 20.0002C39.9983 31.0459 31.044 40.0003 19.9983 40.0003C8.95261 40.0003 -0.00170898 31.0459 -0.00170898 20.0002ZM16.3384 28.5603L27.9983 21.2803C28.4347 21.0008 28.6986 20.5184 28.6986 20.0002C28.6986 19.4821 28.4347 18.9997 27.9983 18.7203L16.2983 11.4403C15.8375 11.1497 15.2554 11.1319 14.7776 11.3935C14.2999 11.6553 14.0015 12.1555 13.9984 12.7003V27.3003C13.9919 27.8583 14.2958 28.3738 14.7871 28.6383C15.2784 28.9029 15.876 28.8728 16.3384 28.5603Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play-btn.3b15eb5039b4186194c13e2eb9971618.svg";
export { ForwardRef as ReactComponent };